module.exports = __webpack_public_path__ + "media/images/frontend/vacunate-e0fe3ba8de6ea149459d42fc502400b3.png";